// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"E2-z","dimensionLabel":"F2-z","styleChooserControlWrapper":"G2-z","styleChooserControl":"H2-z","disabled":"I2-z","giftCard":"J2-z","styleChooserText":"K2-z"};